// Get New Arrivals
export const GET_NEW_ARRIVALS_REQUEST = 'GET_NEW_ARRIVALS_REQUEST';
export const GET_NEW_ARRIVALS_DONE = 'GET_NEW_ARRIVALS_DONE';
export const GET_NEW_ARRIVALS_FAILED = 'GET_NEW_ARRIVALS_FAILED';
export const GET_NEW_ARRIVALS_RESET = 'GET_NEW_ARRIVALS_RESET';